import React from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { Form, Input, Select, Upload, notification } from 'antd';

import { ROLES } from '../../../constants';
import './Company.scss';

const CompanyForm = ({ form, users, handleCreateCompany, fileList, setFileList }) => {
  const handleSubmit = (params) => {
    handleCreateCompany && handleCreateCompany(params);
  };

  const handleChange = (info) => {
    let newFileList = [...info.fileList];
    const file = newFileList.slice(-1)[0];
    const isLt5M = (file?.size || 0) / 1024 / 1024 <= 5;
    if (!isLt5M) {
      notification.error({ message: 'Image must smaller than 5MB!' });
    } else {
      newFileList = newFileList.slice(-1);
      setFileList(newFileList);
    }
  };

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return fileList;
  };

  return (
    <div className={`CompanyForm`}>
      <Form form={form} scrollToFirstError layout="vertical" requiredMark={false} colon={false} onFinish={handleSubmit}>
        <div className="FormContent">
          <Form.Item label="Company Name" name="name" rules={[{ required: true, message: 'Required' }]}>
            <Input placeholder="Name" size="large" />
          </Form.Item>

          <Form.Item label="Company Owner" name="companyOwner">
            <Select
              mode="multiple"
              size="large"
              allowClear
              disabled={users.filter((user) => user?.role === ROLES.COMPANY_OWNER && !user.companyId).length === 0}
              placeholder={
                users.filter((user) => user?.role === ROLES.COMPANY_OWNER && !user.companyId).length === 0
                  ? 'Please create a user with role company owner first'
                  : ''
              }
              options={users
                .filter((user) => user?.role === ROLES.COMPANY_OWNER && !user.companyId)
                .map((user) => ({
                  label: user.name,
                  value: user.id,
                }))}
            />
          </Form.Item>
          <Form.Item label="Moneybird ID" name="debtorId" rules={[{ required: true, message: 'Required' }]}>
            <Input placeholder="Debtor ID" size="large" />
          </Form.Item>
          <Form.Item
            label="Logo"
            name="logo"
            validateStatus={!fileList || fileList.length == 0 ? 'error' : undefined}
            help={!fileList || fileList.length == 0 ? 'Required' : undefined}
            getValueFromEvent={normFile}
          >
            <Upload.Dragger
              multiple={false}
              maxCount={1}
              accept=".png, .jpg, .jpeg"
              showUploadList={{
                showPreviewIcon: false,
                showDownloadIcon: false,
                showRemoveIcon: true,
              }}
              customRequest={async ({ onSuccess, onError }) => {
                try {
                  onSuccess('ok');
                } catch (e) {
                  console.log(e);
                  onError();
                }
              }}
              onRemove={() => setFileList([])}
              listType="picture-card"
              fileList={fileList}
              onChange={handleChange}
            >
              <p className="upload-text">Drag and drop to upload or</p>
              <p className="upload-drag-icon">
                Browse
                <UploadOutlined />
              </p>
            </Upload.Dragger>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default CompanyForm;
